<template>
  <el-dialog
    v-dialogDrag
    title="人员证书"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="small-dialog"
  >
    <el-form :model="formData" ref="formRef" v-loading="formLoading">
      <el-form-item label="证书编号" required>
        <el-input
          v-model="formData.certificateNumber"
          size="small"
          placeholder="证书编号"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="证书名称" required>
        <el-input
          v-model="formData.certificateName"
          size="small"
          placeholder="证书名称"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="证书有效期" required>
        <el-date-picker
          size="small"
          v-model="formData.certificateDate"
          type="date"
          placeholder="证书有效期"
          disabled
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="证书复审日期">
        <el-date-picker
          size="small"
          v-model="formData.certificateVerifyDate"
          type="date"
          placeholder="证书复审日期"
          disabled
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="证书附件" required>
        <form-upload v-model="formData.attachment" :disabled="true"></form-upload>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import { find } from 'lodash'
import FormUpload from '@/components/safety/FileUpload/FormUpload'
import { ContractorPersonnelCertificateApi } from '@wiz-api/contractor-management'

const contractorPersonnelCertificateApi = new ContractorPersonnelCertificateApi()

export default {
  name: 'CredentialDetail',
  components: {
    FormUpload,
  },
  props: {
    visible: {
      default: false,
      type: Boolean,
    }, // 是否显示弹窗
    certificateId: {
      type: String,
      default: '',
    }, // 证书id
    contractorPersonnelId: {
      type: String,
      default: '',
    }, // 人员id
  },
  data() {
    return {
      formData: {
        certificateNumber: '', // 证书编号
        certificateName: '', // 证书名称
        certificateDate: '', // 证书有效期
        certificateVerifyDate: '', // 证书复审日期
        attachment: '', // 证书附件
      },
      formLoading: false, // 表单详情数据loading
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    /**
     * @description 获取证书列表数据
     */
    async getCertificateList() {
      this.formLoading = true
      const [err, res] = await contractorPersonnelCertificateApi.contractorPersonnelCertificateDto({
        contractorPersonnelId: this.contractorPersonnelId,
      })
      this.formLoading = false
      if (!err) {
        const certificate = find(res, (item) => {
          return item.id === this.certificateId
        })
        if (certificate) {
          this.formData = { ...certificate }
          this.formData.attachment = certificate.certificateFileId
          return
        }
        this.formData = this.$options.data().formData
      }
    },
  },

  created() {
    this.getCertificateList()
  },
}
</script>
<style lang="scss" scoped></style>
